import React, { useRef } from "react";
import styles from "./Accordion.module.css";

const Accordion = ({ title, content, isOpen, toggleAccordion }) => {
  const contentRef = useRef(null); // To calculate the height of the content

  return (
    <div className={styles.accordion}>
      <div
        className={`${styles.accordionHeader} ${isOpen ? styles.active : ""}`}
        onClick={toggleAccordion}
      >
        {title}
        <span className={styles.icon}>{isOpen ? "−" : "+"}</span>
      </div>
      <div
        className={styles.accordionBody}
        style={{
          maxHeight:
            isOpen && contentRef.current
              ? `${contentRef.current.scrollHeight}px` // access only if contentRef.current exists
              : "0", // Defensive check added here
          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
        ref={contentRef}
      >
        <div className={styles.accordionContent}>{content}</div>
      </div>
    </div>
  );
};

export default Accordion;
